import React, { useRef, useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { ICON_SAVE, ICON_CANCEL } from '../../extras/icons';
//Redux
import { useDispatch, useSelector } from 'react-redux';
import { saveResultModalitiesAction, updateResultModalitiesAction } from '../../../actions/resultModalitiesActions';
import { Formik } from 'formik';
import ButtonSpinner from '../../layout/ButtonSpinner';
import * as yup from 'yup';
import { setLocale } from 'yup';
//Función principal
const ResultModalityForm = props => {
    //Tomo los props
    const { show, handleClose } = props;
    //Genero los refs
    const refDescription = useRef();
    //Datos iniciales
    const initialData = {
        descripcion: ''
    }
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Traigo el store de persona tipos
    const resultModalitiesLoading = useSelector( state => state.resultModalities.loadingSave );
    const errorSave = useSelector( state => state.resultModalities.errorSave );
    const isEdit = useSelector( state => state.resultModalities.isEdit );
    const resultModalitySelected = useSelector( state => state.resultModalities.resultModalitySelected );
    //Inicializo el state local
    const [ resultModality, setAudienceMotive ] = useState(initialData);
    //Modifico según el cambio
    useEffect(() => {
        //Me fijo si es edición
        if(isEdit && resultModalitySelected){
            setAudienceMotive(resultModalitySelected);
        }else{
            setAudienceMotive(initialData);
        }
    }, [isEdit, resultModalitySelected, show])
    //Manejo de cambios
    const handleChange = e => {
        setAudienceMotive({
            ...resultModality,
            [e.target.name]: e.target.value
        })
    }
    //Manejo el guardado
    const handleSave = values => {
        //Inicializo los datos
        let data = {
            ...resultModality,
            activo: 1
        }
        //Agrego los nuevos valores
        data = {
            ...data,
            ...values
        }
        //Verifico si es edición o alta
        if(resultModality.id){
            //Es edición
            dispatch( updateResultModalitiesAction(data, handleCloseForm) );
        }else{
            //Es creación
            dispatch( saveResultModalitiesAction(data, handleCloseForm) );
        }
    }
    //Manejo cuando se muestra
    const handleOnShow = e => {
        //Pongo el foco en el primer campo
        refDescription.current.focus();
    }
    //Manejo cierre de la ventana
    const handleCloseForm = () => {
        //Reinicio datos
        setAudienceMotive(initialData);
        //Cierro
        handleClose();
    }
    //Esquema de validación
    const validationSchema = yup.object({
        descripcion: yup.string().required()
    });
    //Renderizo
    return (
        <Modal show={show} onHide={handleCloseForm} onShow={handleOnShow} aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    Resultado Modalidad&nbsp;
                    <small><strong>{ isEdit ? 'Editar' : 'Nuevo' } Registro</strong></small>
                </Modal.Title>
            </Modal.Header>
            <Formik
                enableReinitialize
                validationSchema={validationSchema}
                initialValues={{ ...resultModality }}
                onSubmit={ values => handleSave(values) }
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    touched,
                    isValid,
                    errors,
                    isSubmitting
                }) => (
                    <form noValidate onSubmit={handleSubmit} autoComplete="off">
                        <Modal.Body>
                            <div className="row">
                                <Form.Group className="col-md-12">
                                    <label htmlFor="descripcion">Descripción</label>
                                    <Form.Control
                                        id="descripcion"
                                        className="form-control" 
                                        autoFocus 
                                        name="descripcion" 
                                        type="text" 
                                        value={ values.descripcion }
                                        onChange={handleChange}
                                        ref={refDescription}
                                        isInvalid={!!errors.descripcion}
                                        disabled={ resultModalitiesLoading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.descripcion }
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            {
                                resultModalitiesLoading ? (
                                    <ButtonSpinner />
                                ) : (
                                    <Button variant="success" type="submit" disable={ resultModalitiesLoading }>
                                        <ICON_SAVE /> <strong>{ isEdit ? 'ACTUALIZAR' : 'GUARDAR' }</strong>
                                    </Button>
                                )
                            }
                            <Button variant="secondary" onClick={handleCloseForm} disabled={ resultModalitiesLoading }>
                                <ICON_CANCEL /> Cancelar
                            </Button>
                        </Modal.Footer>
                    </form>
                )}
            </Formik>
        </Modal>
    );
};

export default ResultModalityForm;